<template>
  <div class="container" style="margin-top: 50px;">
    <form name="signupForm">
      <div class="panel panel-default">
        <div class="panel-body" style="padding-top: 10px;">
          <div class="row">
            <div class="form-group col-md-12">
              <div class="pull-left">
                <img src="~assets/images/logbox_logo_sm.png" style="margin-top: 15px; margin-right: 11px;">
              </div>
              <div class="pull-left">
                <h1 v-if="role === 'TRAINEE'">Signup for LogBox Academic - Email Verification</h1>
                <h1 v-if="role === 'HOD'">Signup for LogBox Academic - Supervisor Activation</h1>
              </div>
            </div>
          </div>
          <error-display v-if="errorMessage">{{errorMessage}}</error-display>
          <div v-if="verified">Your account has now been activated. Please click the button below to login.</div>
        </div>
        <div class="panel-footer">
          <div class="row">
            <div class="col-md-12">
              <div style="text-align: right; width: 100%">
                <div style="display: inline; float: right">
                  <button v-if="verified" type="button" id="login-submit-button" name="login-submit-button"
                          class="btn btn-primary btn-block" @click="redirectLogin()">
                    Login
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import ErrorDisplay from 'components/common/outputs/ErrorDisplay';

  export default {
    name: 'verify-email',
    components: {
      ErrorDisplay,
    },
    data: () => ({
      role: '',
      verified: false,
      errorMessage: '',
    }),
    methods: {
      async verifyEmail(verificationData) {
        try {
          await this.$api.verifyEmail(verificationData);
          this.verified = true;
        } catch (error) {
          this.errorMessage = this.$api.processError(error);
        }
      },
      redirectLogin() {
        this.$router.push('Login');
      },
    },
    mounted() {
      this.role = this.$route.query.role;
      this.$store.dispatch('updateContext', {
        context: 'academic',
      });
      this.verifyEmail({
        emailAddress: this.$route.query.email,
        verificationCode: this.$route.query.verificationCode,
      });
    },
  };
</script>



// WEBPACK FOOTER //
// VerifyEmail.vue?7887708b